<template>
    <v-container fluid>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialogInitial" persistent max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('selecciona_caseta')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form
                                @submit.prevent="setGuardHouse()">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                        v-model="guardHouse"
                                        name="guardHouse"
                                        :items="guardHouses"
                                        item-text="name"
                                        item-value="id"
                                        :label="$t('Casetas')"
                                        autocomplete="off"
                                ></v-autocomplete>
                            </v-col>
                            <v-btn
                                    color="primary"
                                    type="submit"
                            >{{ $t('aceptar') }}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogAdditionalPersonCode"
                persistent
                scrollable
                width="500">
            <v-card class="elevation-5">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{ $t('additional_person') }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogAdditionalPersonCode = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-col>
                        <v-row aling="center">
                            <h3>{{$t('select_video_device')}}</h3>
                        </v-row>
                        <v-row>
                            <v-col cols="10">
                                <v-select
                                        small
                                        v-model="camera3"
                                        :items="devices"
                                        label="Persona"
                                        item-text="label"
                                        item-value="deviceId"
                                ></v-select>
                            </v-col>
                            <v-col cols="2">
                              <v-icon large @click="onStart3">mdi-refresh</v-icon>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-card
                            class="mx-auto"
                            tile
                    >
                        <v-img
                                width="100%"
                                :src="imageCapturedAdditionalPerson !== '' ? imageCapturedAdditionalPerson : require('../../assets/noimage.png')"
                        >
                            <v-row
                                    align="end"
                                    class="fill-height"
                            >
                                <v-col
                                        align-self="start"
                                        class="pa-0"
                                        cols="12"
                                >
                                    <v-avatar
                                            class="profile"
                                            color="grey"
                                            size="164"
                                            tile
                                    >
                                        <div v-show="band" @click="onCaptureAdditionalPerson()">
                                            <vue-web-cam
                                                    ref="webcam3"
                                                    :device-id="deviceId3"
                                                    width="100%"
                                                    @started="onStarted3"
                                                    @stopped="onStopped"
                                                    @error="onError"
                                                    @cameras="onCameras"
                                                    @camera-change="onCameraChange3"
                                            />
                                        </div>
                                    </v-avatar>
                                </v-col>
                            </v-row>
                        </v-img>
                    </v-card>
                  <div class="text-center">
                    {{$t('msg_captura_foto')}}
                  </div>
                    <br><br>
                    <v-text-field
                      v-model="editedItem.full_name"
                      autofocus
                      prepend-icon="mdi-account"
                      name="first_name"
                      :label="$t('Nombre')"
                      outlined>
                    </v-text-field>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                        large
                        color="error"
                        @click="dialogAdditionalPersonCode = false"
                    >{{$t('cerrar')}}
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                        :disabled="editedItem.full_name.length === 0 || imageCapturedAdditionalPerson === ''"
                        large
                        color="success"
                        @click="addResident()"
                    >{{$t('agregar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card
                width="1500"
                class="mx-auto elevation-7 font-weight-bold"
        >
            <v-toolbar dark color="primary">
                <v-icon v-if="getProfile.enable_parcel === false">mdi-truck</v-icon>
                <v-checkbox hide-details class="shrink mr-2" v-if="getProfile.enable_parcel === false" v-model="bandParcel" color="black"></v-checkbox>
                        {{getProfile.enable_parcel === false ? $t('parcel_capital_letters') : ''}}
                        <v-btn text router to="/events"><v-icon >mdi-calendar-star</v-icon>{{$t('events')}}</v-btn>
                        <v-btn text router to="/delivery"><v-icon>mdi-moped</v-icon>Delivery</v-btn>
                        <v-spacer/>
                <v-toolbar-title>
                    {{$t('access_without_code')}}
                </v-toolbar-title>
                <v-spacer/>
                <v-switch v-if="devices.length > 1" v-model="bandOneCam" color="secondary" label="Usar sólo una Cámara"></v-switch>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col
                            cols="12"
                            sm="6"
                    >
                        <v-alert
                            v-show="bandMsgVacationMode"
                            type="error"
                            outlined
                        >
                          <strong>{{$t('aviso')}}: {{$t('msg_vacation_mode')}}</strong>
                        </v-alert>
                        <v-alert
                            v-show="bandInstructions"
                            type="info"
                            outlined
                        >
                          <strong>{{ msgInstructions }}</strong>
                        </v-alert>
                        <br>
                        <v-autocomplete
                            v-if="getProfile.idHousingUnit !== 'bc7c051d-56eb-4dbf-b627-eca69ece6541'"
                            v-show="bandParcel"
                            v-model="idHouse2"
                            :search-input.sync="searchInput"
                            @change="searchInput=''"
                            prepend-icon="mdi-home-city"
                            name="idHouse2"
                            :item-text="example"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_street_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            outlined
                            multiple
                            chips
                            clearable
                            autocomplete="off"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >
                              {{ data.item.street }} {{data.item.number}}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title>{{ data.item.street }} {{data.item.number}}</v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-else
                            v-show="bandParcel"
                            v-model="idHouse2"
                            :search-input.sync="searchInput"
                            @change="searchInput=''"
                            prepend-icon="mdi-home-city"
                            name="idHouse2"
                            :item-text="example"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            outlined
                            multiple
                            chips
                            clearable
                            autocomplete="off"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                                large
                                v-if="getProfile.show_house_phones === false"
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >
                              <strong>{{ data.item.street }} {{data.item.number}}</strong>
                            </v-chip>
                            <v-chip
                                v-else
                                large
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close
                                @click="data.select"
                                @click:close="remove(data.item)"
                            >
                              <strong>{{ data.item.street }} {{data.item.number}} ({{data.item.phone === null ? 'n/a' : data.item.phone}}) ({{data.item.phone2 === null ? 'n/a' : data.item.phone2}}) ({{data.item.phone3 === null ? 'n/a' : data.item.phone3}})</strong>
                            </v-chip>
                          </template>
                          <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                            <v-spacer/>
                            <v-btn-toggle>
                              <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </template>
                          <template v-slot:item="data" v-else>
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-show="getProfile.booth_registration === false && !bandParcel"
                            v-model="idHouse"
                            prepend-icon="mdi-home-city"
                            name="idHouse"
                            :item-text="getProfile.show_house_phones === false ? example : example2"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_street_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            clearable
                            outlined
                            return-object
                            autocomplete="off"
                            @change="showMessageVacationMode"
                        >
                          <template v-slot:item="data" v-if="getProfile.show_house_phones === false">
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                            <v-spacer/>
                            <v-btn-toggle>
                              <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                              <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                <v-icon>mdi-phone</v-icon>
                              </v-btn>
                            </v-btn-toggle>
                          </template>
                          <template v-slot:item="data" v-else>
                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-show="getProfile.booth_registration === true && getProfile.idHousingUnit === 'bc7c051d-56eb-4dbf-b627-eca69ece6541' && !bandParcel"
                            v-model="idHouse"
                            prepend-icon="mdi-home-city"
                            name="idHouse"
                            :item-text="getProfile.show_house_phones === false ? example : example2"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_street_house_number')"
                            :filter="customFilterNumber"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            clearable
                            outlined
                            return-object
                            autocomplete="off"
                            @change="showMessageVacationMode"
                        >
                          <template v-slot:item="data">
                            <template v-if="getProfile.show_house_phones === false">
                              <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                              <v-spacer/>
                              <v-btn-toggle>
                                <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                              </v-btn-toggle>
                            </template>
                            <template v-else>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                  </v-list-item-title>
                                </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <v-autocomplete
                            v-show="getProfile.booth_registration === true && getProfile.idHousingUnit !== 'bc7c051d-56eb-4dbf-b627-eca69ece6541' && !bandParcel"
                            v-model="idHouse"
                            prepend-icon="mdi-home-city"
                            name="idHouse"
                            :item-text="getProfile.show_house_phones === false ? example : example3"
                            item-value="id"
                            :label="$t('casas')"
                            :placeholder="$t('search_by_house_number_resident')"
                            :filter="customFilterNumberResident"
                            :error-messages="errors.house"
                            :items="houses"
                            no-data-text="Ningún Resultado"
                            clearable
                            outlined
                            return-object
                            autocomplete="off"
                            @change="showMessageVacationMode"
                        >
                          <template v-slot:item="data">
                            <template v-if="getProfile.show_house_phones === false">
                              <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>
                              <v-spacer/>
                              <v-btn-toggle>
                                <v-btn v-if="data.item.phone !== null" icon large color="primary" :href="`tel:${data.item.phone}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone2 !== null" icon large color="primary" :href="`tel:${data.item.phone2}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                                <v-btn v-if="data.item.phone3 !== null" icon large color="primary" :href="`tel:${data.item.phone3}`">
                                  <v-icon>mdi-phone</v-icon>
                                </v-btn>
                              </v-btn-toggle>
                            </template>
                            <template v-else>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} ) ( {{data.item.phone2 === null ? 'n/a' : data.item.phone2}} ) ( {{data.item.phone3 === null ? 'n/a' : data.item.phone3}} )</strong>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{data.item.fullname === '' ? 'n/a' : data.item.fullname}}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <div class="text--accent-1" v-show="getProfile.show_directory_guards === true && !bandParcel">
                          <div class="ml-6" v-show="idHouse.phone !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name1 === null) || (idHouse.name1 === '')) ? 'n/a' : idHouse.name1}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone2 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name2 === null) || (idHouse.name2 === '')) ? 'n/a' : idHouse.name2}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone2}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone3 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name3 === null) || (idHouse.name3 === '')) ? 'n/a' : idHouse.name3}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone3}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone4 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name4 === null) || (idHouse.name4 === '')) ? 'n/a' : idHouse.name4}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone4}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone5 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name5 === null) || (idHouse.name5 === '')) ? 'n/a' : idHouse.name5}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone5}}</strong></h2><br></div>
                          <div class="ml-6" v-show="idHouse.phone6 !== null && idHouse.phone !== undefined"><h5>{{((idHouse.name6 === null) || (idHouse.name6 === '')) ? 'n/a' : idHouse.name6}}</h5><h2>
                          <v-icon>mdi-phone</v-icon><strong>{{idHouse.phone6}}</strong></h2><br></div><br>
                        </div>
                        <v-autocomplete
                                v-show="!bandParcel"
                                v-model="idService"
                                prepend-icon="mdi-tag-multiple"
                                name="idService"
                                :item-text="textServices"
                                item-value="name"
                                :label="$t('service_catalog')"
                                :placeholder="$t('search_by_name')"
                                :filter="customFilterService"
                                :items="services"
                                no-data-text="Ningún Resultado"
                                clearable
                                outlined
                                autocomplete="off"
                        >
                            <template v-slot:item="data">
                                <strong>{{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                            </template>
                        </v-autocomplete>
                        <v-text-field
                                v-model="first_name"
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('Nombre')"
                                outlined
                                :error-messages="errors.name_guest"
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="last_name"
                                prepend-icon="mdi-account-outline"
                                name="last_name"
                                :label="$t('Apellido')"
                                outlined
                                :error-messages="errors.name_guest"
                        >
                        </v-text-field>
                        <v-textarea
                                v-model="notes"
                                autocomplete="on"
                                prepend-icon="mdi-text"
                                name="notes"
                                :placeholder="$t('placeholder_notas')"
                                :label="$t('Notas')"
                                outlined
                                :error-messages="errors.comments"
                        ></v-textarea>
                        <div align="center">
                            <v-btn
                                    large
                                    color="primary"
                                    @click="createAccessNoCode()"
                                    :loading="loading"
                            >{{$t('enviar')}}
                            </v-btn>
                        </div>
                        <v-btn
                            v-if="bandParcel === false"
                            color="primary"
                            @click="cleanAdditionalPersonFields()"
                        >{{$t('additional_person')}}</v-btn>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="12">
                            <div v-if="bandParcel === false">
                              <v-data-table
                                  :headers="headers"
                                  :items="additionalPersons"
                                  :footer-props="{
                                        itemsPerPageOptions: [
                                            {text: '5', value: 5},
                                            {text: '10', value: 10},
                                            {text: '25', value: 25},
                                            {text: this.$t('todos'), value: -1}
                                        ],
                                        itemsPerPageText: $t('filas_por_pagina')
                                    }"
                                  :no-data-text="$t('no_records_yet')"
                                  class="elevation-1"
                              >
                                <template v-slot:item.full_name="{ item }">
                                  {{ item.full_name}}
                                </template>
                                <template v-slot:item.action="{ item }">
                                  <v-icon
                                      medium
                                      color="grey"
                                      class="mr-2"
                                      @click="editResident(item)"
                                  >
                                    mdi-pencil
                                  </v-icon>
                                  <v-icon
                                      medium
                                      color="red"
                                      @click="deleteResident(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </div>
                          </v-col>
                        </v-row>
                    </v-col>
                    <v-col
                            cols="12"
                            sm="6"
                    >
                        <v-layout justify-center class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" row wrap>
                            <v-col>
                                <v-row aling="center">
                                    <h3>{{$t('select_video_device')}}</h3>
                                </v-row>
                                <v-row>
                                <v-col cols="6">
                                    <v-select
                                            small
                                            v-model="camera"
                                            :items="devices"
                                            label="Persona"
                                            item-text="label"
                                            item-value="deviceId"
                                    ></v-select>
                                </v-col>
                                <v-col v-if="devices.length > 1 && !bandOneCam" cols="6">
                                    <v-select
                                            v-model="camera2"
                                            :items="devices"
                                            label="Placas"
                                            item-text="label"
                                            item-value="deviceId"
                                    ></v-select>
                                </v-col>
                                </v-row>
                            </v-col>
                            <v-card
                                    class="mx-auto"
                                    tile
                            >
                                <v-img
                                        width="100%"
                                        :src="imageCaptured !== '' ? imageCaptured : require('../../assets/noimage.png')"
                                >
                                    <v-row
                                            align="end"
                                            class="fill-height"
                                    >
                                        <v-col
                                                align-self="start"
                                                class="pa-0"
                                                cols="12"
                                        >
                                            <v-avatar
                                                    class="profile"
                                                    color="grey"
                                                    size="164"
                                                    tile
                                            >
                                                <div v-show="band2" @click="onCapture()">
                                                    <vue-web-cam
                                                            ref="webcam"
                                                            :device-id="deviceId"
                                                            width="100%"
                                                            @started="onStarted"
                                                            @stopped="onStopped"
                                                            @error="onError"
                                                            @cameras="onCameras"
                                                            @camera-change="onCameraChange"
                                                    />
                                                </div>
                                            </v-avatar>
                                            <v-avatar
                                                    v-show="devices.length > 1 && !bandOneCam"
                                                    class="profile"
                                                    color="grey"
                                                    size="164"
                                                    tile
                                            >
                                                <div v-show="band2" @click="onCapture()">
                                                    <vue-web-cam
                                                            ref="cameraDos"
                                                            :device-id="deviceId2"
                                                            width="100%"
                                                            @started="onStarted"
                                                            @stopped="onStopped"
                                                            @error="onError"
                                                            @camera-change="onCameraChange2"
                                                    />
                                                </div>
                                            </v-avatar>
                                        </v-col>
                                    </v-row>
                                </v-img>
                            </v-card>
                                <br>
                                <v-alert
                                        v-if="errors.photo"
                                        type="error"
                                        outlined
                                        transition="scale-transition"
                                >
                                    {{errors.photo}}
                                </v-alert>
                                <br>
                            {{$t('msg_captura_foto')}}
                        </v-layout>
                    </v-col>
                </v-row>
              <div v-show="false">
                <vue-web-cam
                        ref="webcam3"
                        :device-id="deviceId3"
                        width="100%"
                        @stopped="onStopped"
                        @error="onError"
                />
              </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { WebCam } from 'vue-web-cam'
import store from '@/store'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'access_without_code',
  components: {
    'vue-web-cam': WebCam
  },
  data () {
    return {
      camera: null,
      camera2: null,
      camera3: null,
      devices: [ ],
      deviceId: null,
      deviceId2: null,
      deviceId3: null,
      band: false,
      band2: false,
      houses: [],
      imageCaptured: '',
      imageCapturedAdditionalPerson: '',
      imageCaptured2: '',
      errors: [],
      first_name: '',
      last_name: '',
      celular: '',
      // band_cellphone: false,
      notes: '',
      idHouse: {
        id: ''
      },
      idHouse2: [],
      searchInput: '',
      dialogInitial: false,
      guardHouse: null,
      guardHouses: [],
      loading: false,
      bandOneCam: false,
      bandParcel: false,
      bandMsgVacationMode: false,
      bandInstructions: false,
      msgInstructions: '',
      idService: '',
      services: [],
      // VARIABLES AGREGAR ACOMPANANTES
      dialogAdditionalPersonCode: false,
      bandAdditionalPersonCode: false,
      headers: [],
      additionalPersons: [],
      editedIndex: -1,
      edit: false,
      editedItem: {
        full_name: '',
        data: '',
        classification: '',
        label: ''
      },
      defaultItem: {
        full_name: '',
        data: '',
        classification: '',
        label: ''
      },
      imageCapturedAdditional: '',
      // VARIABLES AGREGAR ACOMPANANTES
      idGuestByEvent: null,
      idGuestByDelivery: null
    }
  },
  created: async function () {
    await this.getHouses()
    await this.getServices()
    await this.getGuardHouse()
    if (localStorage.getItem('idGuardHouse') === null) {
      this.dialogInitial = true
    }
    if (this.getProfile.booth_registration === true) {
      this.bandOneCam = true
    }
    console.log(this.$route.params)
    console.log('Tamaño =', Object.keys(this.$route.params).length)
    if (Object.keys(this.$route.params).length > 2) {
      if (this.$route.params.type === 0) { // EVENTO
        this.first_name = this.$route.params.fullNameGuest + ' (EVENTO)'
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByEvent = this.$route.params.idGuestByEvent
        this.notes = this.$route.params.eventName
      } else { // DELIVERY
        this.idHouse.id = this.$route.params.idHouse
        this.idGuestByDelivery = this.$route.params.idGuestByDelivery
        this.notes = this.$route.params.notes
      }
    }
  },
  computed: {
    ...mapGetters(['getProfile']),
    device () {
      return this.devices.find(n => n.deviceId === this.deviceId)
    }
  },
  watch: {
    camera (id) {
      this.deviceId = id
    },
    camera2 (id) {
      this.deviceId2 = id
    },
    camera3 (id) {
      this.deviceId3 = id
    },
    devices () {
      console.log('Hola')
      // Once we have a list select the first one
      const [first, second, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
        this.camera3 = first.deviceId
        this.deviceId3 = first.deviceId
      } else {
        this.camera = tail.deviceId
        this.deviceId = tail.deviceId
        this.camera3 = first.deviceId
        this.deviceId3 = first.deviceId
      }
      if (this.devices.length > 1) {
        this.camera2 = second.deviceId
        this.deviceId2 = second.deviceId
        this.camera3 = first.deviceId
        this.deviceId3 = first.deviceId
      }
    }
  },
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'full_name'
      }
    ]
  },
  methods: {
    remove: function (item) {
      console.log(this.idHouse2)
      console.log(this.idHouse2[0])
      const index = this.idHouse2.indexOf(item.id)
      console.log(index)
      if (index >= 0) this.idHouse2.splice(index, 1)
    },
    deleteHeadFromImages (imagen) {
      return imagen.replace('data:image/jpeg;base64,', '')
    },
    async asyncCall () {
      const mergeImages = require('merge-base64')
      const result = await mergeImages([this.imageCaptured, this.imageCaptured2], { 'direction': true })
      this.imageCaptured = result
    },
    onCapture () {
      this.imageCaptured = this.$refs.webcam.capture()
      if (this.devices.length > 1 && !this.bandOneCam) {
        this.imageCaptured2 = this.$refs.cameraDos.capture()
        this.imageCaptured = this.deleteHeadFromImages(this.imageCaptured)
        this.imageCaptured2 = this.deleteHeadFromImages(this.imageCaptured2)
        this.asyncCall()
      }
    },
    onCaptureAdditionalPerson () {
      this.imageCapturedAdditionalPerson = this.$refs.webcam3.capture()
    },
    onStarted (stream) {
      this.band2 = true
      console.log('On Started Event', stream)
    },
    onStarted3 (stream) {
      this.band = true
      console.log('On Started Event 3', stream)
    },
    onStopped (stream) {
      console.log('On Stopped Event', stream)
    },
    onStop () {
      this.$refs.webcam.stop()
      this.$refs.webcam3.stop()
      this.$refs.cameraDos.stop()
    },
    onStart () {
      this.$refs.webcam.start()
      this.$refs.webcam3.start()
      this.$refs.cameraDos.start()
    },
    onStart3 () {
      this.$refs.webcam3.start()
      this.onCameraChange3(this.deviceId3)
    },
    onError (error) {
      console.log('On Error Event', error)
    },
    onCameras (cameras) {
      this.devices = cameras
      console.log('On Cameras Event', cameras)
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    onCameraChange2 (deviceId) {
      this.deviceId2 = deviceId
      this.camera2 = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    onCameraChange3 (deviceId) {
      this.deviceId3 = deviceId
      this.camera3 = deviceId
      console.log('On Camera Change Event', deviceId)
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/resident_house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.houses = []
          } else {
            this.houses = response.data
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getServices: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/service/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.services = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    example2: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')',
    example3: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')' + ' (' + (item.phone2 === null ? 'n/a' : item.phone2) + ')' + ' (' + (item.phone3 === null ? 'n/a' : item.phone3) + ')' + ' (' + (item.fullname === '' ? 'n/a' : item.fullname) + ')',
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    textServices: item => (item.name === null ? 'n/a' : item.name),
    customFilterNumberResident (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.number.toLowerCase() + item.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      }
      const searchText = queryText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      return text.indexOf(searchText) > -1
    },
    showMessageVacationMode () {
      console.log('Fill Houses')
      console.log(this.idHouse)
      if (this.idHouse === undefined) {
        this.idHouse = {
          id: ''
        }
        this.bandMsgVacationMode = false
        this.bandInstructions = false
        this.msgInstructions = ''
      } else {
        if (this.idHouse.vacation_mode && !this.idHouse.allow_access_visitors) {
          this.bandMsgVacationMode = true
        } else {
          this.bandMsgVacationMode = false
        }
        if (this.idHouse.instructions !== '' && this.idHouse.instructions !== null) {
          this.bandInstructions = true
          this.msgInstructions = this.idHouse.instructions
        } else {
          this.bandInstructions = false
          this.msgInstructions = ''
        }
      }
    },
    customFilterStreetResident (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.fullname.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      }
      const searchText = queryText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterNumber (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.street.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() + ' ' + item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilterService (item, queryText) {
      var text = ''
      if (item.name === null) {
        text = 'n/a'
      } else {
        text = item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanAdditionalPersonFields () {
      console.log('URL = ', this.$route.name)
      this.dialogAdditionalPersonCode = true
      this.imageCapturedAdditionalPerson = ''
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.onStart3()
    },
    addResident () {
      this.editedItem.full_name = this.editedItem.full_name
      this.editedItem.data = this.imageCapturedAdditionalPerson
      if (this.editedIndex > -1) {
        Object.assign(this.additionalPersons[this.editedIndex], this.editedItem)
      } else {
        this.additionalPersons.push(this.editedItem)
        console.log(this.editedItem)
        console.log('Resident Added')
      }
      this.dialogAdditionalPersonCode = false
    },
    editResident (item) {
      // console.log('ITEM = ', item)
      this.editedIndex = this.additionalPersons.indexOf(item)
      // console.log('INDEX EDIT ITEM = ', this.editedIndex)
      this.editedItem = Object.assign({}, item)
      this.imageCapturedAdditionalPerson = this.editedItem.data
      this.dialogAdditionalPersonCode = true
    },
    deleteResident (aResident) {
      const index = this.additionalPersons.indexOf(aResident)
      confirm('¿Está seguro de eliminar el Registro de ' + aResident.full_name + '?.\nEsta Acción no se puede deshacer!') && this.additionalPersons.splice(index, 1)
    },
    createRecordsAdditionalPeopleNoCode (id) {
      console.log('TAM ====> ', this.additionalPersons.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      for (let i = 0; i < this.additionalPersons.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('idAccess', id)
        bodyFormData.append('full_name', this.additionalPersons[i].full_name)
        fileImageFront = this.dataURLtoFile(this.additionalPersons[i].data, 'photo' + newID + '.jpeg')
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/additional_people_no_code_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    createManyAccessNoCode () {
      this.loading = true
      this.errors = []
      console.log('TAM ====> ', this.idHouse2.length)
      var bodyFormData = new FormData()
      var fileImageFront = null

      for (let i = 0; i < this.idHouse2.length; i++) {
        const newID = this.$uuid.v4()
        bodyFormData.append('housing_unit', this.getProfile.idHousingUnit)
        bodyFormData.append('house', this.idHouse2[i])
        bodyFormData.append('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))
        bodyFormData.append('name_guest', this.first_name + ' ' + this.last_name)
        bodyFormData.append('comments', this.notes)
        if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
          fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
        }
        bodyFormData.append('photo', fileImageFront)
      }
      console.log(bodyFormData)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_many_create/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('access_success'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    createAccessWithoutCode () {
      this.loading = true
      this.errors = []
      console.log('Access Without Code Created ....')
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()

      bodyFormData.set('housing_unit', this.getProfile.idHousingUnit)
      bodyFormData.set('house', this.idHouse.id)
      if (this.idService !== undefined && this.idService.length > 0 && (this.first_name !== '' || this.last_name !== '')) {
        bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name + ' ' + '(' + this.idService.toUpperCase() + ')')
      } else {
        bodyFormData.set('name_guest', this.first_name + ' ' + this.last_name)
      }
      bodyFormData.set('comments', this.notes)
      if (this.additionalPersons.length > 0) {
        bodyFormData.set('additionalPerson', 'true')
      }
      bodyFormData.set('id_guardhouse_checkin', localStorage.getItem('idGuardHouse'))

      if (this.imageCaptured !== '' && this.imageCaptured.length > 6) {
        fileImageFront = this.dataURLtoFile(this.imageCaptured, 'photo' + newID + '.jpeg')
      }
      bodyFormData.append('photo', fileImageFront)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/access_no_code_create_get/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          console.log('ID del nuevo registro = ', ok.data.id)
          if (this.additionalPersons.length > 0) {
          //   Llamar a funcion que genere registros de personas adicionales
            this.createRecordsAdditionalPeopleNoCode(ok.data.id)
          } else {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('access_success'))
            setTimeout(this.clear, 3000)
          }
          if (this.idGuestByEvent !== null) {
            console.log('Se actualiza Registro de Acceso de la invitado al Evento.')
            this.changeStatusGuestByEvent(ok.data.id)
          }
          if (this.idGuestByDelivery !== null) {
            console.log('Se actualiza Registro de Acceso al Delivery.')
            this.changeStatusGuestByDelivery(ok.data.id)
          }
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errors = error.response.data
          }
        })
    },
    changeStatusGuestByEvent (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/event/guest/status/' + this.idGuestByEvent + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    changeStatusGuestByDelivery (uuid) {
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/delivery/' + this.idGuestByDelivery,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          status: 1,
          idAccessNoCode: uuid
        }
      }
      axios(config)
        .then(ok => {
          console.log('Status del invitado al Evento actualizado Correctamente.', ok)
        })
        .catch(error => {
          console.log('Error al cambiar status del invitado al Evento.', error)
        })
    },
    createAccessNoCode () {
      console.log('idHouse = ', this.idHouse)
      console.log('idHouse2 = ', this.idHouse2)
      if (this.bandParcel === true) {
        this.createManyAccessNoCode()
      } else {
        this.createAccessWithoutCode()
      }
    },
    getGuardHouse: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/guardhouse/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.guardHouses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    setGuardHouse () {
      if (this.guardHouse !== null) {
        localStorage.setItem('idGuardHouse', this.guardHouse)
        this.dialogInitial = false
      }
    },
    cleanFields () {
      this.errors = []
      this.notes = ''
      this.idHouse = {
        id: ''
      }
      this.idHouse2 = []
      this.idService = ''
      this.first_name = ''
      this.last_name = ''
      this.imageCaptured = ''
      this.imageCapturedAdditionalPerson = ''
      this.bandMsgVacationMode = false
      this.bandInstructions = false
      this.msgInstructions = ''
      this.bandParcel = false
      this.additionalPersons = []
      this.idGuestByEvent = null
      this.idGuestByDelivery = null
    },
    clear: function () {
      this.cleanFields()
      this.errors = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
